/**
 * Do the default from menu transition logic.
 *
 * @param  {JSON} response
 * @param  {ctx} ctx
 * @return {void}
 */
export default (response, ctx) => {
    let app = document.getElementById('page');

    app.classList.add('setup-transition');
    app.classList.add('in-transition');

    EventBus.$once('close-menu-complete', () => {
        app = document.getElementById('page');
        app.classList.remove('setup-transition');

        TweenMax.delayedCall(2, () => {
            app.classList.remove('in-transition');
        });
    });

    // Pass the component definition to the resolve callback
    window.requestAnimationFrame(() => {
        app.innerHTML = response.data;

        window.scrollTo(0, 0);

        EventBus.$once('page-transition-mounted', () => {
            EventBus.$emit('page-story-init');
            App.router.pageTransitionComplete();
            App.closeNavigation();
        });

        // Rebuild Vue
        App.router.buildPage('#page');
    });
};



// WEBPACK FOOTER //
// ./resources/assets/js/navigation/transitions/default-from-menu.js